import React from 'react';

import { PublicFooter, PublicHeader } from 'components';

import OrderApproval from '../orderConfirmations/containers/OrderApproval';

import shared from 'styles/Shared.module.scss';

const OrderApprovalPage = () => {
  return (
    <>
      <PublicHeader supplierForm />
      <div className={shared.publicContainer}>
        <OrderApproval />
      </div>
      <PublicFooter />
    </>
  );
};

export default OrderApprovalPage;
